const t = {
  "cdr-tab-panel": "cdr-tab-panel_13-5-3",
  "cdr-tab-panel-enter-left": "cdr-tab-panel-enter-left_13-5-3",
  "cdr-tab-panel-enter-right": "cdr-tab-panel-enter-right_13-5-3",
  "cdr-tab-panel-exit-left": "cdr-tab-panel-exit-left_13-5-3",
  "cdr-tab-panel-exit-right": "cdr-tab-panel-exit-right_13-5-3"
};
export {
  t as default
};
